import React from 'react';
import { Button } from '@/components/ui/button';
import backgroundVideo from '@/images/home_background11.mp4';
import skillsVideo from '@/images/skills.mp4';

const AboutSection = () => {
  return (
    <section id="about" className="bg-secondary py-24">
      <div className="container mx-auto">
        <h5 className=' text-primary mb-6 font-Urbanist font-medium tracking-widest text-xl'>About Me</h5>
        <h2 className="section-heading font-light tracking-widest sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl">Hey👋,Welcome to My Creative Blueprint😉</h2>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          {/* Profile Image Column */}
          <div className="flex justify-center" data-animation="animate-fade-in-right">
            <div className="relative">
              <div className="w-64 h-[26rem] rounded-full overflow-hidden border-4 border-primary">
                {/*
                <img 
                  src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?q=80&w=600&auto=format&fit=crop"
                  alt="Profile" 
                  className="w-full h-full object-cover"
                />
                */}
                <video
                  autoPlay
                  loop
                  muted
                  playsInline
                  className="w-full h-full object-cover"
                >
                  <source src={backgroundVideo} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
              <div className="absolute -bottom-4 -right-4 bg-primary text-primary-foreground p-4 rounded-full shadow-lg">
                <svg xmlns="Time Sheet TRA 28th April 2025" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-code"><polyline points="16 18 22 12 16 6"></polyline><polyline points="8 6 2 12 8 18"></polyline></svg>
              </div>
            </div>
          </div>
          
          {/* Content Column */}
          <div data-animation="animate-fade-in-left">
            <h3 className="text-xl  mb-4 font-Urbanist font-medium tracking-widest">Hi, I’m Thamodya — a passionate UI/UX Designer with 2 years of experience crafting intuitive digital experiences.</h3>
            <p className="text-muted-foreground mb-6 text-lg tracking-widest">
            A proud graduate of Sabaragamuwa University of Sri Lanka, I currently work as a UI/UX Engineer, where I blend creativity and strategy to design user-centric interfaces that not only look good but feel right.
              <br />
              I'm deeply curious about how users think, feel, and interact. That’s why I’m constantly learning, exploring new trends, and diving deeper into the art of meaningful user experiences. My goal? To design solutions that are simple, seamless, and human.            </p>
              <p className="text-muted-foreground mb-6 text-lg tracking-widest">
            Let’s build something users will love✨
            </p>
            
           
           
            {/* CTA Button */}
            {/* <Button asChild>
              <a href="/path-to-cv.pdf" download="YourName-CV.pdf">Download CV</a>
            </Button> */}
          </div>

          
          
        </div>
         {/* Skills Video */}
         {/* <div className="mb-8 relative">
              <h4 className="font-semibold mb-3">My Skills in Action</h4>
              <div className="rounded-lg overflow-hidden border border-border">
                <video
                  autoPlay
                  loop
                  muted
                  playsInline
                  className="w-full h-auto max-h-72 object-cover absolute"
                >
                  <source src={skillsVideo} type="video/mp4" />
                  Your browser does not support the video tag.
                </video> */}
                  {/* Skills */}
            {/* <div className="mb-8 relative"> */}
              {/* <h4 className="font-semibold mb-3">My Skills</h4> */}
              {/* <div className="flex flex-wrap gap-2"> */}
                {/* {["Figma", "UX Design","HTML", "CSS", "JavaScript", "React", "Tailwind CSS", "TypeScript"].map(skill => (
                  <span key={skill} className="px-3 py-1 bg-background rounded-full text-sm">
                    {skill}
                  </span>
                ))}
              </div> */}
            {/* </div> */}
              {/* </div> */}
            
      </div>
    </section>
  );
};

export default AboutSection;